module.exports = __webpack_public_path__ + "img/logo.7484d28c.png";